import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { Filiere } from './filiere.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { InterNodo } from './internodo.model';
import { Complaint } from './complaint.model';


export const FILIERE_ENDPOINT='water-supply-system';
export const FILIERE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(FILIERE_ENDPOINT);

export const filiereStateConfig: SignalStoreConfig<QueryState<Filiere>> = {
    initState: {
      list: []
    }
  }

export const INTERNODO_ENDPOINT='node-link';
export const INTERNODO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(INTERNODO_ENDPOINT);

export const CATALOG_SPINNERET_ENDPOINT = 'catalog-spinneret';
export const CATALOG_SPINNERET_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CATALOG_SPINNERET_ENDPOINT);


export const NODE_ENDPOINT = 'node';
export const NODE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(NODE_ENDPOINT);

export const CATALOG_SECTION_ENDPOINT = 'catalog-section';
export const CATALOG_SECTION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CATALOG_SECTION_ENDPOINT);


export const PRIORITY_BUILDING_ENDPOINT = 'priority-buildings';
export const PRIORITY_BUILDING_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRIORITY_BUILDING_ENDPOINT);

export const catalogSectionStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const priorityBuildingStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const nodeStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}


export const catalogSpinneretStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const internodoStateConfig: SignalStoreConfig<QueryState<InterNodo>> = {
    initState: {
      list: []
    }
  }

export const COMPLAINT_ENDPOINT='complaint';
export const COMPLAINT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(COMPLAINT_ENDPOINT);

export const complaintStateConfig: SignalStoreConfig<QueryState<Complaint>> = {
    initState: {
      list: []
    }
  }


export const LISTA_FILIERE_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'

  },

  {
    name: 'servedMunicipalitiesCount',
    label: 'Numero Comuni',
    field: 'servedMunicipalitiesCount',
    type: 'text',

  },
  {
    name: 'servedPopulationCount',
    label: 'Abitanti',
    field: 'servedPopulationCount',
    type: 'text',

  },
    {
    name: 'suppliedWaterVolume',
    label: 'Volume (m3/anno)',
    field: 'suppliedWaterVolume',
    type: 'text',

  },
    {
    name: 'commitmentDate',
    label: 'Inizio Gestione',
    field: 'commitmentDate',
    type: 'datetime',

  },
  
   {
    name: 'commitmentType',
    label: 'Tipologia Affidamento',
    field: 'commitmentType',
    type: 'text',

  },
];

export const LISTA_FILIERE_VISIBLECOLUMNS = [
  'select',
  'name',
  'servedMunicipalitiesCount',
  'servedPopulationCount',
  'suppliedWaterVolume',
  'commitmentDate',
  'commitmentType',
  'azioni'
];


export const TIPOLOGIA_AFFIDAMENTO_OPTIONS = [
  {
    value: 'DIRECT',
    label: 'Affidamento diretto'
  },
  {
    value: 'TENDER',
    label: 'Concessione'
  },
  {
    value: 'PPP',
    label: 'Gara pubblica'
  }
  
]

export const MODALITA_GESTIONE_OPTIONS = [
  {
    value: 'DIRECT',
    label: 'Diretta'
  },
  {
    value: 'INDIRECT',
    label: 'Indiretta'
  }
]

export const NODES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice nodo',
    field: 'code',
    type: 'text'

  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type: 'text'

  },
  {
    name: 'sintaiId',
    label: 'Identificativo SINTAI',
    field: 'sintaiId',
    type: 'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type: 'text'
  },
  {
    name: 'active',
    label: 'Attivo',
    field: 'active',
    type: 'boolean'
  },
]

export const NODES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'sintaiId',
  'description',
  'active',
  'azioni'
]

export let NODES_DATATABLE_FILTER_COLUMNS: ITableColumn[] = [

  {
    name: 'code',
    label: 'Codice nodo',
    field: 'code',
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'
  },
  {
    name: 'sintaiId',
    label: 'Identificativo SINTAI',
    field: 'sintaiId',
    type:'text'
  },
];

export enum NODE_TYPES_ENUM {
  CAPTAZIONE = 'CAPTAZIONE',
  ADDUZIONE = 'ADDUZIONE',
  TRATTAMENTO = 'TRATTAMENTO',
  ACCUMULO = 'ACCUMULO',
  DISTRIBUZIONE = 'DISTRIBUZIONE',
}

export const NODE_TYPES = [
  {
  id: 1,
  code: 'CAPTAZIONE',
  name: 'Captazione',
  fields: [],
  sections: []
  },
  {
  id: 2,
  code: 'ADDUZIONE',
  name: 'Adduzione',
  fields: [],
  sections: []
  },
  // {
  // id: 3,
  // code: 'TRATTAMENTO',
  // name: 'Trattamento',
  // fields: [],
  // sections: []
  // },
  {
  id: 4,
  code: 'ACCUMULO',
  name: 'Accumulo',
  fields: [],
  sections: []
  },
  {
  id: 5,
  code: 'DISTRIBUZIONE',
  name: 'Distribuzione',
  fields: [],
  sections: []
  },
]


export const INTERNODES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice nodo',
    field: 'code',
    type: 'text'

  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type: 'text'

  },
  {
    name: 'direction',
    label: 'Direzione',
    field: 'direction',
    type: 'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type: 'text'
  },
  {
    name: 'note',
    label: 'note',
    field: 'note',
    type: 'text'
  },

  {
    name: 'startNodeId',
    label: 'Nodo A',
    field: 'startNodeId',
    type: 'text'
  },
    {
    name: 'endNodeId',
    label: 'Nodo B',
    field: 'endNodeId',
    type: 'text'
  },
   {
    name: 'active',
    label: 'Attivo',
    field: 'active',
    type: 'boolean'
  },
]

export const INTERNODES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'direction',
  'description',
  'startNodeId',
  'endNodeId',
  'active',
  'azioni'
]

export const COMPLAINT_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'year',
    label: 'Anno',
    field: 'year',
    type: 'text'

  },
  {
    name: 'clientRef',
    label: 'Codice Reclamo',
    field: 'clientRef',
    type: 'text'

  },
  {
    name: 'numberHandled',
    label: 'Reclami gestiti nell\'anno',
    field: 'numberHandled',
    type: 'text'

  }
]

export const COMPLAINT_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  // 'clientRef',
  'year',
  'numberHandled',
  'azioni'
]

export const PRIORITY_BUILDING_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'description',
    label: 'Nome edificio',
    field: 'description',
    type: 'text'

  },
  {
    name: 'volume',
    label: 'Volume annuo',
    field: 'volume',
    type: 'text'

  },
  {
    name: 'longitude',
    label: 'Coordinata x',
    field: 'longitude',
    type: 'text'
  },
  {
    name: 'latitude',
    label: 'Coordinata y',
    field: 'latitude',
    type: 'text'
  }
]

export const PRIORITY_BUILDING_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'description',
  'volume',
  'longitude',
  'latitude',
  'azioni'
]

export const SECTIONS_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome sezione',
    field: 'name',
    type: 'text'

  },
  {
    name: 'code',
    label: 'Codice sezione',
    field: 'code',
    type: 'text'

  }
]

export const SECTIONS_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'name',
  'code',
  'azioni'
]


export const SCHEDULED_ACTIVITIES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'date',
    label: 'Data di inizio',
    field: 'date',
    type: 'text'

  },
  {
    name: 'length',
    label: 'Lunghezza sostituito',
    field: 'length',
    type: 'text'

  },
  {
    name: 'materialsNoteOldSection',
    label: 'Materiali tratto sostituito',
    field: 'materialsNoteOldSection',
    type: 'text'
  },
  {
    name: 'materialsNoteNewSection',
    label: 'Materiali nuovo tratto',
    field: 'materialsNoteNewSection',
    type: 'text'

  }
]

export const SCHEDULED_ACTIVITIES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'date',
  'length',
  'materialsNoteOldSection',
  'materialsNoteNewSection',
  'azioni'
]

export const EXTRAORDINARY_ACTIVITIES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'year',
    label: 'Anno di riferimento',
    field: 'year',
    type: 'text'

  },
  {
    name: 'number',
    label: 'Numero di interventi',
    field: 'number',
    type: 'number'

  },
  {
    name: 'description',
    label: 'Descirizione degli interventi',
    field: 'description',
    type: 'text'
  },
]

export const EXTRAORDINARY_ACTIVITIES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'year',
  'number',
  'description',
  'azioni'
]
